AFRAME.registerComponent("open-upload-form", {
  init() {
    const template = document.querySelector("#media-frame-placeholder");

    this.el.appendChild(document.importNode(template.content, true).children[0]);

    // Initialize tick counters for timing
    this.initTicks = 0;
    this.playTicks = 0;
    this.initDelay = 60; // 60 ticks ≈ 1000ms at 60fps
    this.playDelay = 60; // 60 ticks ≈ 1000ms at 60fps

    this.onClick = () => {
      // Emit to scene the open-upload-form event
      this.el.sceneEl.emit("open-upload-form");
    };
  },

  tick() {
    // Handle init delay
    if (this.initTicks < this.initDelay) {
      this.initTicks++;
      if (this.initTicks === this.initDelay) {
        this.setupUploadButton();
      }
    }

    // Handle play delay
    if (this.playTicks < this.playDelay) {
      this.playTicks++;
      if (this.playTicks === this.playDelay) {
        this.setupInteractListener();
      }
    }
  },

  setupUploadButton() {
    const menu = this.el.querySelector(".open-upload-form-button").parentElement;
    this.openUploadFormButton = menu.querySelector(".open-upload-form-button");

    // Find the guide object
    let guide = null;
    this.el.object3D.traverse(o => {
      if (o.name === "guide") {
        guide = o;
      }
    });

    this.openUploadFormButton.classList.add("media_frame_eid_" + guide.eid);

    const plane = new THREE.BoxGeometry(1, 1, 0.001);
    const material = new THREE.MeshBasicMaterial({
      color: 0xffffff,
      transparent: true,
      opacity: 0,
      side: THREE.DoubleSide,
      depthWrite: false,
      depthTest: false
    });

    const mesh = new THREE.Mesh(plane, material);
    mesh.position.set(0, 0, 0);
    mesh.scale.set(0.5, 0.5, 0.5);

    this.openUploadFormButton.setObject3D("mesh", mesh);
  },

  setupInteractListener() {
    if (this.openUploadFormButton && this.openUploadFormButton.object3D) {
      this.openUploadFormButton.object3D.addEventListener("interact", this.onClick);
    }
  },

  play() {
    // Reset play ticks when component starts playing
    this.playTicks = 0;
  },

  pause() {
    if (this.openUploadFormButton && this.openUploadFormButton.object3D) {
      this.openUploadFormButton.object3D.removeEventListener("interact", this.onClick);
    }
  }
});
